import { ENDPOINTS } from '../constants/endpoints';
import { Role } from '../interfaces/RoleManagementInterfaces';
import { ApiClient } from '../../Shared/interfaces/ApiClient';

const { ROLES } = ENDPOINTS;

/**
 * Fetches all roles and their permissions from the API
 * @param api - The API client instance
 * @returns Promise that resolves to roles data
 */
export const getRoles = (
  api: ApiClient,
  selectedArtEventId: string | null | undefined
) => {
  const endpoint = selectedArtEventId
    ? `${ROLES}?artEventId=${encodeURIComponent(selectedArtEventId)}`
    : ROLES;
  return api.get(endpoint);
};

/**
 * Updates role permissions via API
 * @param api - The API client instance
 * @param payload - The role object with updated permissions
 * @returns Promise that resolves to the API response
 */
export const editRole = (
  api: ApiClient,
  selectedArtEventId: string | null | undefined,
  payload: Role
) => {
  const { userRole, permissions } = payload;
  return api.put(ROLES, {
    artEventId: selectedArtEventId,
    role: { userRole, permissions },
  });
};
